import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    bulkUpdateEventAttendanceApi,
    declareMyEventAbsenceApi,
    fetchEventAttendanceApi,
} from "../../services/eventAttendanceApi";
import {
    bulkUpdateEventAttendanceFailure,
    bulkUpdateEventAttendanceSuccess,
    declareMyEventAbsenceFailure,
    declareMyEventAbsenceSuccess,
    fetchEventAttendanceFailure,
    fetchEventAttendanceRequest,
    fetchEventAttendanceSuccess,
    setEventAttendanceLoading,
    setEventAttendanceSubmitting,
} from "../actions/eventAttendanceActions";

export function* fetchEventAttendanceSaga(action) {
    yield put(setEventAttendanceLoading(true));
    try {
        const response = yield call(fetchEventAttendanceApi, action.payload.eventId);
        yield put(fetchEventAttendanceSuccess(action.payload.eventId, response.data));
    } catch (error) {
        yield put(fetchEventAttendanceFailure(error.response?.data?.message || error.message));
    } finally {
        yield put(setEventAttendanceLoading(false));
    }
}

export function* bulkUpdateEventAttendanceSaga(action) {
    yield put(setEventAttendanceSubmitting(true));
    try {
        const response = yield call(
            bulkUpdateEventAttendanceApi,
            action.payload.eventId,
            action.payload.items
        );

        yield put(bulkUpdateEventAttendanceSuccess(action.payload.eventId, response.data));
        yield put(fetchEventAttendanceRequest(action.payload.eventId));
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Absences mises à jour",
            text: response.data?.message || "Les statuts de présence ont été enregistrés.",
            timer: 2200,
            showConfirmButton: false,
        });
    } catch (error) {
        const message = error.response?.data?.message || error.message || "Erreur de mise à jour";
        yield put(bulkUpdateEventAttendanceFailure(message));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: message,
        });
    } finally {
        yield put(setEventAttendanceSubmitting(false));
    }
}

export function* declareMyEventAbsenceSaga(action) {
    yield put(setEventAttendanceSubmitting(true));
    try {
        const response = yield call(
            declareMyEventAbsenceApi,
            action.payload.eventId,
            action.payload.payload
        );

        yield put(declareMyEventAbsenceSuccess(action.payload.eventId, response.data));
        yield put(fetchEventAttendanceRequest(action.payload.eventId));
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "Absence declarée",
            text: "Votre absence a bien été enregistrée.",
            timer: 2200,
            showConfirmButton: false,
        });
    } catch (error) {
        const message = error.response?.data?.message || error.message || "Erreur de déclaration";
        yield put(declareMyEventAbsenceFailure(message));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "Erreur",
            text: message,
        });
    } finally {
        yield put(setEventAttendanceSubmitting(false));
    }
}
